import { Colors } from '..';
import generateGradient from './generateGradient';

const gray = {
  conical: generateGradient(
    [Colors.Gray[600], Colors.Gray[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient([Colors.Gray[600], Colors.Gray[500]], 'linear', {
    originDeg: 90,
    percent: [0, 100],
  }),
  linear02: generateGradient([Colors.Gray[700], Colors.Gray[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
  linear03: generateGradient([Colors.Gray[800], Colors.Gray[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
  linear04: generateGradient([Colors.Gray[800], Colors.Gray[600]], 'linear', {
    originDeg: 90,
    percent: [0, 100],
  }),
  linear05: generateGradient([Colors.Gray[800], Colors.Gray[700]], 'linear', {
    originDeg: 26.5,
    percent: [0, 100],
  }),
  linear06: generateGradient([Colors.Gray[900], Colors.Gray[600]], 'linear', {
    originDeg: 45,
    percent: [0, 100],
  }),
} as const;

export default gray;
